(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fe-product-assist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fe-product-assist')) {
  customElements.define('fe-product-assist', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}-${this.dataset.product}`);
      if (!this.info) return;
      const signal = this.controller.signal;
      this.mediaQuery = window.matchMedia('(max-width: 989px)');
      this.sync = () => {
        const bounds = this.info.getBoundingClientRect();
        const buttons = [...this.info.querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"]')];
        const buttonVisible = buttons.some(button => {
          if (!button.getClientRects().length) return false;
          const box = button.getBoundingClientRect();
          return box.bottom > 0 && box.top < window.innerHeight;
        });
        const modalOpen = document.documentElement.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden') || document.querySelector('dialog[open],[aria-modal="true"][open]');
        this.hidden = !this.mediaQuery.matches || bounds.top > 120 || (!this.hasAttribute('data-journey') && bounds.bottom < 0) || buttonVisible || !!modalOpen;
        const price = this.querySelector('[data-fe-assist-price]');
        const total = this.info.querySelector('[data-fe-total]')?.textContent;
        if (price && total && price.textContent !== total) price.textContent = total;
      };
      let scheduled = false;
      window.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { this.sync(); scheduled = false; });
      }, { passive: true, signal });
      window.addEventListener('resize', this.sync, { passive: true, signal });
      document.addEventListener('click', () => requestAnimationFrame(this.sync), { signal });
      this.info.addEventListener('fe:summary-updated', this.sync, { signal });
      this.querySelector('[data-fe-options]').addEventListener('click', () => {
        const target = this.info.querySelector('[data-fe-stage="colors"]') || this.info.querySelector('.gpo-app,variant-picker') || this.info;
        const top = target.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const input = target.querySelector('input:not([type="hidden"]):not([disabled]),select,button');
        if (input) input.focus({ preventScroll: true });
      }, { signal });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
